import creditCardType from 'credit-card-type';

import {
  PayLoadValue,
  TokenizerV1PreprocessorParameters,
} from '@cashier/cashier-model';

export const DataConverter = {
  toAuthToken: (parameters: TokenizerV1PreprocessorParameters): string => {
    return btoa(`${parameters.username}:${parameters.password}`);
  },
  toTokenizePayload: (payload: { [name: string]: { value: PayLoadValue } }) => {
    const [cardExpireMonth, cardExpireYear] = (
      payload.expirationDate.value as string
    ).split('/');

    const cardNumber = payload.creditcardNumber?.value as string;
    const cardType = creditCardType(cardNumber)[0]?.type || 'unknown';

    return {
      paymentMethod: cardType,
      holder: payload.cardHolder?.value as string,
      cardNumber: cardNumber,
      expiryMonth: Number(cardExpireMonth),
      expiryYear: Number(cardExpireYear),
      cvc: payload.cvv?.value as string,
    };
  },
  toMaskedCardNumber: (cardNumber: string): string => {
    const cardWithoutSpaces = cardNumber.replaceAll(/\s/g, '');
    return cardWithoutSpaces.replace(
      /^(\d{6})(\d+)(\d{4})$/,
      (_, first6, middle, last4) => {
        return first6 + 'x'.repeat(middle.length) + last4;
      },
    );
  },
};
